export default "//file.bilionpass.com/japandx-web/0.0.1/static/num_03.6bc0921c-b2ffd5.svg";